import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-HOMEPAGE",
  "use": "rt-portal-HOMEPAGE-usage",
  "viewBox": "-1111 -61 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"-1111 -61 1024 1024\" id=\"rt-portal-HOMEPAGE\">\r\n<path d=\"M-192.6,444.5L-554,83.3l-24.2-24.2c-11.5-11.4-30-11.4-41.5,0l-385.6,385.5c-11.5,11.5-17.7,26.8-17.6,43\r\n\tc0.4,32.9,27.8,59.2,60.7,59.2h39.8v304.6h647.1V546.8h40.6c16,0,31.1-6.3,42.4-17.6c11.3-11.3,17.5-26.4,17.5-42.4\r\n\tC-175,470.9-181.3,455.9-192.6,444.5L-192.6,444.5z M-546.6,784.1h-104.8V593.3h104.8V784.1z M-342.8,479.4v304.6h-144V570.8\r\n\tc0-20.7-16.7-37.4-37.4-37.4h-149.7c-20.7,0-37.4,16.7-37.4,37.4v213.3h-144V479.4H-945l346.1-345.8l21.6,21.6l324.4,324.2H-342.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/HOMEPAGE.svg
// module id = 1290
// module chunks = 124